import { GET_WORKSHOP_LEVEL_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_WORKSHOP_LEVEL_RECIPES_SUCCESS: {
      const workshopLevelRecipes = action.payload;
      console.log('here you go pal: ', workshopLevelRecipes);

      if (!workshopLevelRecipes){
        return [...state];
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
